/**
 * Creative Gallery: infinite auto-scrolling rows with drag, arrows and hover-play videos.
 */
document.addEventListener('DOMContentLoaded', function () {
    var rows = document.querySelectorAll('.cgw-row');
    if (!rows.length) return;

    function loadVideo(video) {
        var source = video.querySelector('source[data-src]');
        if (!source || source.src) return;
        source.src = source.dataset.src;
        video.load();
    }

    // Clone cards in each row for seamless infinite loop
    rows.forEach(function (row) {
        Array.from(row.children).forEach(function (card) {
            var clone = card.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('img').forEach(function (img) {
                img.setAttribute('loading', 'lazy');
                img.setAttribute('decoding', 'async');
            });
            row.appendChild(clone);
        });
    });

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rowObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            entry.target.dataset.visible = entry.isIntersecting ? 'true' : 'false';
        });
    }, { rootMargin: '250px 0px' }) : null;

    // Smooth rAF scroll — pause on hover
    rows.forEach(function (row) {
        var rtl = row.dataset.dir === 'rtl';
        var speed = 0.6; // px per frame (~36px/s at 60fps)
        var paused = false;
        row.dataset.visible = rowObserver ? 'false' : 'true';
        if (rowObserver) rowObserver.observe(row);
        if (reduceMotion) return;

        requestAnimationFrame(function () {
            var half = row.scrollWidth / 2;

            // RTL rows start at the midpoint so reverse scroll has content to show
            if (rtl) row.scrollLeft = half;

            (function tick() {
                if (!paused && row.dataset.visible === 'true') {
                    if (rtl) {
                        row.scrollLeft -= speed;
                        if (row.scrollLeft <= 0) row.scrollLeft += half;
                    } else {
                        row.scrollLeft += speed;
                        if (row.scrollLeft >= half) row.scrollLeft -= half;
                    }
                }
                requestAnimationFrame(tick);
            })();
        });

        // Drag to scroll
        var isDown = false;
        var startX;
        var scrollLeftPos;
        var dragged = false;

        row.addEventListener('mouseenter', function () { paused = true; });
        row.addEventListener('mouseleave', function () { paused = false; isDown = false; row.classList.remove('is-dragging'); });

        row.addEventListener('mousedown', function (e) {
            isDown = true;
            paused = true;
            dragged = false;
            row.classList.add('is-dragging');
            startX = e.pageX - row.offsetLeft;
            scrollLeftPos = row.scrollLeft;
        });
        row.addEventListener('mouseup', function () {
            isDown = false;
            row.classList.remove('is-dragging');
        });
        row.addEventListener('mousemove', function (e) {
            if (!isDown) return;
            e.preventDefault();
            var walk = (e.pageX - row.offsetLeft - startX) * 2;
            if (Math.abs(walk) > 5) dragged = true;
            row.scrollLeft = scrollLeftPos - walk;
        });
        row.addEventListener('click', function (e) {
            if (dragged) {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        // Touch events
        row.addEventListener('touchstart', function (e) {
            isDown = true;
            paused = true;
            startX = e.touches[0].pageX - row.offsetLeft;
            scrollLeftPos = row.scrollLeft;
        }, { passive: true });
        row.addEventListener('touchend', function () { isDown = false; });
        row.addEventListener('touchmove', function (e) {
            if (!isDown) return;
            var walk = (e.touches[0].pageX - row.offsetLeft - startX) * 2;
            row.scrollLeft = scrollLeftPos - walk;
        }, { passive: true });

        // Arrows navigation
        var wrapper = row.closest('.cgw-row-wrapper');
        if (wrapper) {
            var prevBtn = wrapper.querySelector('.cgw-prev');
            var nextBtn = wrapper.querySelector('.cgw-next');
            var firstCard = row.querySelector('.cgw-media-card');
            var step = firstCard ? firstCard.offsetWidth + 20 : 300;

            [[prevBtn, -1], [nextBtn, 1]].forEach(function (pair) {
                if (!pair[0]) return;
                pair[0].addEventListener('click', function (e) {
                    e.preventDefault();
                    paused = true;
                    row.scrollBy({ left: pair[1] * step, behavior: 'smooth' });
                    setTimeout(function () { paused = false; }, 700);
                });
            });
        }
    });

    // Video: play on hover, pause+reset on leave, toggle mute on click (clones included)
    document.querySelectorAll('.cgw-media-card--vid').forEach(function (card) {
        var video = card.querySelector('video');
        if (!video) return;

        card.style.cursor = 'pointer';

        card.addEventListener('mouseenter', function () {
            loadVideo(video);
            video.play().catch(function () {});
        });
        card.addEventListener('mouseleave', function () {
            video.pause();
            video.currentTime = 0;
            video.muted = true;
        });
        card.addEventListener('click', function (e) {
            e.stopPropagation();
            loadVideo(video);
            video.muted = !video.muted;
            video.play().catch(function () {});
        });
    });
});
